import TextButton from 'LuxKit/Button/TextButton'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useToggle from 'hooks/useToggle'
import React, { useRef } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import useExperiencesSortOptions from '../hooks/useExperiencesSortOptions'
import ExperiencesSortByOptions from './ExperiencesSortByOptions'

const DesktopChevron = styled(DropdownChevron)`
  display: none;

  ${mediaQueryUp.tablet} {
    display: block;
  }
`

function ExperienceSearchPageSort() {
  const intl = useIntl()
  const [open, toggleSort, _, closeSort] = useToggle()
  const triggerRef = useRef<HTMLButtonElement>(null)
  const { sortBy, sortOptions } = useExperiencesSortOptions()

  return (
    <>
      <TextButton
        kind="secondary"
        variant="dark"
        onClick={toggleSort}
        endIcon={<DesktopChevron open={open} />}
        ref={triggerRef}
      >
        {intl.formatMessage({
          id: 'biuHNo2XDjdT5f8l_1L3',
          defaultMessage: 'Sort: {sortOption}',
          description: 'Sort button label showing the currently selected sort option in experience search',
        }, { sortOption: sortOptions[sortBy]?.label })}
      </TextButton>
      <DropdownList
        size="S"
        open={open}
        onClose={closeSort}
        anchorRef={triggerRef}
        triggerRef={triggerRef}
        data-testid="sort-options-dropdown"
      >
        <ExperiencesSortByOptions />
      </DropdownList>
    </>
  )
}

export default ExperienceSearchPageSort
